/* eslint-disable max-lines */
import museumData from './musea-municipalities.json';
import natureAreas from './nature-areas';

const curatedCityFeatures = [
  ['Antwerpen', 'Antwerpen', 4.4025, 51.2194],
  ['Brugge', 'West-Vlaanderen', 3.2247, 51.2093],
  ['Brussel', 'Brussel', 4.3517, 50.8503],
  ['Gent', 'Oost-Vlaanderen', 3.7174, 51.0543],
  ['Hasselt', 'Limburg', 5.3378, 50.9307],
  ['Leuven', 'Vlaams-Brabant', 4.7005, 50.8798],
  ['Mechelen', 'Antwerpen', 4.4777, 51.0259],
  ['Oostende', 'West-Vlaanderen', 2.912, 51.2243],
  ['Turnhout', 'Antwerpen', 4.9447, 51.3225],
];

const PROVINCE_BY_MUNICIPALITY = {
  Aalst: 'Oost-Vlaanderen',
  Aarschot: 'Vlaams-Brabant',
  Alken: 'Limburg',
  Alveringem: 'West-Vlaanderen',
  Anderlecht: 'Brussel',
  Antwerpen: 'Antwerpen',
  Anzegem: 'West-Vlaanderen',
  Arendonk: 'Antwerpen',
  Assenede: 'Oost-Vlaanderen',
  'Baarle-Hertog': 'Antwerpen',
  Balen: 'Antwerpen',
  Beersel: 'Vlaams-Brabant',
  Begijnendijk: 'Vlaams-Brabant',
  Beringen: 'Limburg',
  Berlaar: 'Antwerpen',
  Berlare: 'Oost-Vlaanderen',
  'Beveren-Kruibeke-Zwijndre': 'Oost-Vlaanderen',
  Blankenberge: 'West-Vlaanderen',
  Bocholt: 'Limburg',
  Bonheiden: 'Antwerpen',
  Boom: 'Antwerpen',
  Bornem: 'Antwerpen',
  Boutersem: 'Vlaams-Brabant',
  Brakel: 'Oost-Vlaanderen',
  Brecht: 'Antwerpen',
  Bredene: 'West-Vlaanderen',
  Bree: 'Limburg',
  Brugge: 'West-Vlaanderen',
  Brussel: 'Brussel',
  Damme: 'West-Vlaanderen',
  'De Panne': 'West-Vlaanderen',
  Deerlijk: 'West-Vlaanderen',
  Deinze: 'Oost-Vlaanderen',
  Dendermonde: 'Oost-Vlaanderen',
  Dessel: 'Antwerpen',
  Destelbergen: 'Oost-Vlaanderen',
  Diest: 'Vlaams-Brabant',
  Diksmuide: 'West-Vlaanderen',
  Dilbeek: 'Vlaams-Brabant',
  Drogenbos: 'Vlaams-Brabant',
  Duffel: 'Antwerpen',
  Eeklo: 'Oost-Vlaanderen',
  'Elsene/Ixelles': 'Brussel',
  Essen: 'Antwerpen',
  Etterbeek: 'Brussel',
  Evere: 'Brussel',
  Geel: 'Antwerpen',
  Genk: 'Limburg',
  Gent: 'Oost-Vlaanderen',
  Geraardsbergen: 'Oost-Vlaanderen',
  Gingelom: 'Limburg',
  Gistel: 'West-Vlaanderen',
  Grimbergen: 'Vlaams-Brabant',
  Haaltert: 'Oost-Vlaanderen',
  Halen: 'Limburg',
  Halle: 'Vlaams-Brabant',
  'Hamont-Achel': 'Limburg',
  Harelbeke: 'West-Vlaanderen',
  Hasselt: 'Limburg',
  'Hechtel-Eksel': 'Limburg',
  'Heist-op-den-Berg': 'Antwerpen',
  Hemiksem: 'Antwerpen',
  Herentals: 'Antwerpen',
  'Herk-de-Stad': 'Limburg',
  'Heusden-Zolder': 'Limburg',
  Heuvelland: 'West-Vlaanderen',
  Hoeilaart: 'Vlaams-Brabant',
  Hooglede: 'West-Vlaanderen',
  Hoogstraten: 'Antwerpen',
  'Houthalen-Helchteren': 'Limburg',
  Ieper: 'West-Vlaanderen',
  Izegem: 'West-Vlaanderen',
  Jabbeke: 'West-Vlaanderen',
  Jette: 'Brussel',
  Kalmthout: 'Antwerpen',
  Kampenhout: 'Vlaams-Brabant',
  Kapellen: 'Antwerpen',
  Kaprijke: 'Oost-Vlaanderen',
  Keerbergen: 'Vlaams-Brabant',
  'Knokke-Heist': 'West-Vlaanderen',
  Koekelare: 'West-Vlaanderen',
  Koekelberg: 'Brussel',
  Koksijde: 'West-Vlaanderen',
  Kortemark: 'West-Vlaanderen',
  Kortrijk: 'West-Vlaanderen',
  Laakdal: 'Antwerpen',
  Lanaken: 'Limburg',
  Landen: 'Vlaams-Brabant',
  Lebbeke: 'Oost-Vlaanderen',
  Lendelede: 'West-Vlaanderen',
  Lennik: 'Vlaams-Brabant',
  Leopoldsburg: 'Limburg',
  Leuven: 'Vlaams-Brabant',
  Lier: 'Antwerpen',
  Lievegem: 'Oost-Vlaanderen',
  Lint: 'Antwerpen',
  Linter: 'Vlaams-Brabant',
  'Lo-Reninge': 'West-Vlaanderen',
  Lochristi: 'Oost-Vlaanderen',
  Lokeren: 'Oost-Vlaanderen',
  Londerzeel: 'Vlaams-Brabant',
  Maaseik: 'Limburg',
  Maasmechelen: 'Limburg',
  Maldegem: 'Oost-Vlaanderen',
  Mechelen: 'Antwerpen',
  Meise: 'Vlaams-Brabant',
  Menen: 'West-Vlaanderen',
  Merksplas: 'Antwerpen',
  Middelkerke: 'West-Vlaanderen',
  Mol: 'Antwerpen',
  Moorslede: 'West-Vlaanderen',
  Mortsel: 'Antwerpen',
  'Nazareth-De Pinte': 'Oost-Vlaanderen',
  Nieuwpoort: 'West-Vlaanderen',
  Olen: 'Antwerpen',
  Oostende: 'West-Vlaanderen',
  Opwijk: 'Vlaams-Brabant',
  'Oud-Heverlee': 'Vlaams-Brabant',
  'Oud-Turnhout': 'Antwerpen',
  Oudenaarde: 'Oost-Vlaanderen',
  Oudenburg: 'West-Vlaanderen',
  Oudergem: 'Brussel',
  Overijse: 'Vlaams-Brabant',
  Pajottegem: 'Vlaams-Brabant',
  Peer: 'Limburg',
  Pelt: 'Limburg',
  Pittem: 'West-Vlaanderen',
  Poperinge: 'West-Vlaanderen',
  Putte: 'Antwerpen',
  'Puurs-Sint-Amands': 'Antwerpen',
  Ravels: 'Antwerpen',
  Riemst: 'Limburg',
  Rijkevorsel: 'Antwerpen',
  Roeselare: 'West-Vlaanderen',
  Ronse: 'Oost-Vlaanderen',
  Roosdaal: 'Vlaams-Brabant',
  Rotselaar: 'Vlaams-Brabant',
  Rumst: 'Antwerpen',
  Schaarbeek: 'Brussel',
  Schelle: 'Antwerpen',
  'Scherpenheuvel-Zichem': 'Vlaams-Brabant',
  Schilde: 'Antwerpen',
  'Sint-Jans-Molenbeek': 'Brussel',
  'Sint-Joost-ten-Node': 'Brussel',
  'Sint-Katelijne-Waver': 'Antwerpen',
  'Sint-Lambrechts-Woluwe': 'Brussel',
  'Sint-Laureins': 'Oost-Vlaanderen',
  'Sint-Martens-Latem': 'Oost-Vlaanderen',
  'Sint-Niklaas': 'Oost-Vlaanderen',
  'Sint-Pieters-Leeuw': 'Vlaams-Brabant',
  'Sint-Pieters-Woluwe': 'Brussel',
  'Sint-Truiden': 'Limburg',
  'St-Gillis': 'Brussel',
  Stekene: 'Oost-Vlaanderen',
  Tervuren: 'Vlaams-Brabant',
  'Tessenderlo-Ham': 'Limburg',
  'Tielt-Winge': 'Vlaams-Brabant',
  Tienen: 'Vlaams-Brabant',
  'Tongeren-Borgloon': 'Limburg',
  Torhout: 'West-Vlaanderen',
  Tremelo: 'Vlaams-Brabant',
  Turnhout: 'Antwerpen',
  Ukkel: 'Brussel',
  Veurne: 'West-Vlaanderen',
  Vleteren: 'West-Vlaanderen',
  Vorst: 'Brussel',
  Waasmunster: 'Oost-Vlaanderen',
  Waregem: 'West-Vlaanderen',
  Wervik: 'West-Vlaanderen',
  Westerlo: 'Antwerpen',
  Wetteren: 'Oost-Vlaanderen',
  Willebroek: 'Antwerpen',
  Zoersel: 'Antwerpen',
  Zonnebeke: 'West-Vlaanderen',
  Zottegem: 'Oost-Vlaanderen',
  Zulte: 'Oost-Vlaanderen',
  Zwevegem: 'West-Vlaanderen',
};

function createCityFeature({
  name,
  coordinates,
  province = null,
}) {
  return {
    type: 'Feature',
    properties: {
      category: 'city',
      id: `city:${name}`,
      municipality: name,
      name,
      province,
    },
    geometry: { type: 'Point', coordinates },
  };
}

function buildMunicipalityCityFeatures(features) {
  const municipalities = features.reduce((items, feature) => {
    const municipality = feature.properties?.municipality;
    const coordinates = feature.geometry?.coordinates;

    if (!municipality || !Array.isArray(coordinates) || coordinates.length < 2) {
      return items;
    }

    const current = items.get(municipality) || {
      coordinates: [0, 0],
      count: 0,
    };

    items.set(municipality, {
      coordinates: [
        current.coordinates[0] + coordinates[0],
        current.coordinates[1] + coordinates[1],
      ],
      count: current.count + 1,
    });

    return items;
  }, new Map());

  return [...municipalities.entries()].map(([name, item]) => createCityFeature({
    name,
    coordinates: item.coordinates.map(value => value / item.count),
    province: PROVINCE_BY_MUNICIPALITY[name] || null,
  }));
}

const cityFeatures = [...new Map([
  ...buildMunicipalityCityFeatures(museumData.features),
  ...curatedCityFeatures.map(([name, province, longitude, latitude]) => createCityFeature({
    name,
    province,
    coordinates: [longitude, latitude],
  })),
].map(feature => [feature.properties.name, feature])).values()];

const additionalFeatures = [
  ...cityFeatures,
  ...natureAreas.map(area => ({
    type: 'Feature',
    properties: {
      category: 'nature',
      id: `nature:${area.name}`,
      name: area.name,
    },
    geometry: { type: 'Point', coordinates: area.coordinates },
  })),
];

export default {
  ...museumData,
  features: [...museumData.features, ...additionalFeatures],
};